import { Static } from '../../../../static';
import agent from '../../../../api/agent';

const Footer = () => {
	const onCookieClick = () => {
		agent.Tracking.track(Static.fromFooterComponent, Static.urlVeritasPrivacy);
	};

	return (
		<footer className='ms-5 me-5 mt-3'>
			<p className='app-p-bigger'>
				<span className='app-bold'>Veritas S.p.A.</span> P.IVA 03341820276 Santa
				Croce 489 30135 Venezia -{' '}
				<a
					className='app-link'
					href={Static.urlVeritasPrivacy}
					target='_blank'
					rel='noopener noreferrer'
					onClick={onCookieClick}
				>
					Cookie Policy
				</a>
			</p>
		</footer>
	);
};

export default Footer;
